/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAdapter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 6v2h4v2h-4v4h4v2h-4v2h-6a5.998 5.998 0 0 1-5.197-3H2V9h4.803A5.998 5.998 0 0 1 12 6zm-2 2h-4a4 4 0 0 0-3.586 2.225l-.076.176A3.978 3.978 0 0 0 8 12l.001-.072L8 12v.072a3.99 3.99 0 0 0 .338 1.527l.072.167A4 4 0 0 0 12 16h4zm-9.917 3H4v2h2.083a6.014 6.014 0 0 1-.074-.663v-.026l-.002-.025A6.098 6.098 0 0 1 6 12l.002.089L6 12a5.935 5.935 0 0 1 .007-.286l.003-.051A5.95 5.95 0 0 1 6.083 11z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAdapter as Adapter };
